<section class="have-questions-form">
    <div class="have-questions-form-wrapper">
        <div class="intro">
            <div class="container">
                <h2 class="subtitle">Have Questions?</h2>
                <h2 class="subtitle">Want to see a live demonstration?</h2>
                <p>Call us toll-free at <a href="tel:1-800-890-0391" style="text-decoration: none; color:#fff;">1-800-890-0391</a></p>
                <p>or complete the form below and will be in touch with you within 24 hours!</p>
            </div>
        </div>
        <form class="container" [formGroup]="ContactUsForm" (ngSubmit)="SubmitForm()" validate>
            <div class="form-wrp">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label>Select Intro (required)</label>
                            <select formControlName="Intro" class="form-control" aria-required="true">
                                <option selected="selected" value="" disabled="disabled" hidden="hidden">Select...</option>
                                <option value="Mr.">Mr.</option>
                                <option value="Mrs.">Mrs.</option>
                                <option value="Ms.">Ms.</option>
                            </select>
                            <div class="invalid-field" *ngIf="!ContactUsForm.controls['Intro'].value && ContactUsForm.controls['Intro'].touched">
                                <span>Please select one</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Your Full Name (required)</label>
                            <input formControlName="FullName" type="text" class="form-control" autocomplete="off" placeholder="Enter name..." aria-required="true">
                            <div class="invalid-field" *ngIf="!ContactUsForm.controls['FullName'].value && ContactUsForm.controls['FullName'].touched">
                                <span>Please fill out this field</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Your Phone Number</label>
                            <input formControlName="PhoneNumber" class="form-control" type="tel" autocomplete="off" placeholder="Enter phone...">
                            <div class="invalid-field" *ngIf="ContactUsForm.controls['PhoneNumber'].value && ContactUsForm.controls['PhoneNumber'].touched && ContactUsForm.controls['PhoneNumber'].errors?.pattern">
                                <span>Invalid Phone Number</span>
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <label>Your Email (required)</label>
                            <input formControlName="Email" type="email" id="ctl00_cphMain_tbEmail" class="form-control" placeholder="Enter email..." autocomplete="off" aria-required="true">
                            <div class="invalid-field">
                                <div class="invalid-field" *ngIf="!ContactUsForm.controls['Email'].value && ContactUsForm.controls['Email'].touched">
                                    <span>Please fill out this field</span>
                                </div>
                                <div class="invalid-field" *ngIf="ContactUsForm.controls['Email'].value && ContactUsForm.controls['Email'].touched && ContactUsForm.controls['Email'].errors?.pattern">
                                    <span>Invalid Email Address</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                          <div class="recaptcha d-flex flex-column align-items-center align-items-md-start">
                            <div class="recaptcha-title">
                                <p>
                                    This site is protected by reCAPTCHA and the Google
                                    <a href="https://policies.google.com/privacy" title="Privacy Policy">Privacy Policy</a> and
                                    <a href="https://policies.google.com/terms" title="Terms of Service">Terms of Service</a> apply.
                                </p>
                            </div>
                            <div  *ngIf="SendMailMessage" class="validator-wrapper responce-error-message">
                                {{SendMailMessage}}
                            </div>
                          </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Your Subject (required)</label>
                            <input formControlName="Subject" type="text" class="form-control" autocomplete="off" placeholder="Enter subject..." aria-required="true">
                            <div class="invalid-field" *ngIf="!ContactUsForm.controls['Subject'].value && ContactUsForm.controls['Subject'].touched">
                                <span>Please fill out this field</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Your message (required)</label>
                            <textarea formControlName="Message" rows="8" cols="20" class="form-control" autocomplete="off" placeholder="Enter message..."></textarea>
                            <div class="invalid-field" *ngIf="!ContactUsForm.controls['Message'].value && ContactUsForm.controls['Message'].touched">
                                <span>Please fill out this field</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="sending-message" *ngIf="SendMailStep == SendMailStepEnumType.Request" >
                                <div class="lds-ring">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div class="feedback-message">Sending mail...</div>
                            </div>
                            <div class="sended-message" *ngIf="SendMailStep == SendMailStepEnumType.Responce">
                                <div class="wrapper"> <svg class="animated-check" viewBox="0 0 24 24">
                                    <path d="M4.1 12.7L9 17.6 20.3 6.3" fill="none" /> </svg>
                                </div>
                                <div class="feedback-message">Your message sent successfully!</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="submit-wrp">
                  
                    <button class="btn btn-primary">Submit</button>
                </div>
            </div>
        </form>
    </div>
</section>